/**
 *
 * @Copyright 2025 UNLOCKIT DECENTRALIZATION, LDA
 *
 */

import { ReactNode } from 'react';

interface TrackerWrapperProps {
    children: ReactNode;
}

export const TrackerWrapper = (props: TrackerWrapperProps) => {
    const { children } = props;
    return children;
};
